<template>
  <div class="cot modal fade" id="Transfer" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-full" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 col-sm-5 col-lg-5 my-auto">
                <h5 class="modal-title" id="addMeterReadingLabel">Transfer</h5>
              </div>
              <div class="col-3 col-sm-7 my-auto">
                <div>
                  <div>
                    <span>
                      <a class="close">
                        <i
                          class="far fa-times-circle fa-2x"
                          data-dismiss="modal"
                          id="closeAddReading"
                          aria-label="Close"
                        ></i>
                      </a>
                    </span>
                  </div>
                  <div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <el-steps
            v-if="activeStep != 6"
            :active="activeStep"
            finish-status="success"
            align-center
          >
            <el-step title="Getting Started"></el-step>
            <el-step title="Destination Customer"></el-step>
            <el-step title="Bank Details"></el-step>
            <el-step title="Contract Info"></el-step>
            <el-step title="Service Details"></el-step>
            <el-step title="Confirmation Summary"></el-step>
          </el-steps>

          <keep-alive>
            <getting-started v-if="activeStep == 0" @next="next"></getting-started>
            <destination-customer v-if="activeStep == 1" @next="next" @back="back"></destination-customer>
            <bank-details v-if="activeStep == 2" @next="next" @back="back"></bank-details>
            <contract-info v-if="activeStep == 3" @next="next" @back="back"></contract-info>
            <service-details v-if="activeStep == 4" @next="next" @back="back"></service-details>
            <confirmation v-if="activeStep == 5" @next="next" @back="back"></confirmation>
            <complete v-if="activeStep == 6"></complete>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GettingStarted from './views/GettingStarted.vue';
import DestinationCustomer from './views/TransferDestinationCustomer.vue';
import BankDetails from './views/TransferBankDetails.vue';
import ServiceDetails from './views/serviceDetails/TransferServiceDetails.vue';
import ContractInfo from './views/TransferContractInfo.vue';
import Confirmation from './views/TransferConfirmation.vue';
import Complete from './views/TransferComplete.vue';

export default {
  components: {
    GettingStarted,
    DestinationCustomer,
    BankDetails,
    ServiceDetails,
    ContractInfo,
    Confirmation,
    Complete,
  },
  computed: {
    activeStep: {
      get() {
        return this.$store.state.transfer.activeStep;
      },
      set(newActive) {
        this.$store.commit('updateActiveStep', newActive);
      },
    },
  },
  methods: {
    next() {
      this.activeStep++;
    },
    back() {
      this.activeStep--;

      if (
        this.$store.state.transfer.destinationCustomer &&
        !/^DD\w{3}$/.test(this.$store.state.transfer.destinationCustomer.CollectionMethod) &&
        this.activeStep == 2
      )
        --this.activeStep;
    },
  },
};
</script>
